import React from "react";
import { FaBars } from "react-icons/fa";

const ModalSidebar = () => {
  return (
    <div>
      <button>
        <FaBars />
      </button>
    </div>
  );
};

export default ModalSidebar;
